import { useLayoutEffect } from "react";
import { useTypedLocation } from "~/hooks/useTypedLocation";

const ScrollToTop: React.FC = () => {
  const { pathname } = useTypedLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-existing; deps reviewed, auto-fix risks behavior change
  useLayoutEffect(() => {
    // Select the 'main' element and scroll to the top
    const mainElement = document.querySelector("main");

    if (mainElement) {
      mainElement.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    } else {
      // Fallback to window if 'main' is not found
      console.warn("'main' element not found. Falling back to window scroll.");
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
